
import { FC } from 'react'
import * as styles from 'components/features/socialFeed/FeedPost/Verified.styl'
import * as cn from 'classnames'
import SvgIcon from 'components/atoms/SvgIcon'
import SuccessSvg from 'icons/success.svg'

type VerifiedProps = {
  className?: string
}

export const Verified: FC<VerifiedProps> = ({ className }) => (
  <div className={ cn(styles.verified, className) }>
    <div
      className={ styles.verifiedIcon }
      title='Verified'
    >
      <SvgIcon src={ SuccessSvg } />
    </div>
  </div>
)
